import { Component } from '@angular/core'
import { MediaClipboardService } from 'media/services/mediaClipboard.service'

@Component({
  selector: 'media-clipboard',
  templateUrl: './mediaClipboard.component.pug',
})
export class MediaClipboardComponent {
  constructor (
    public mediaClipboard: MediaClipboardService,
  ) { }
}
